/**
 * 关键词相关
 * @author wangyichen
 * @since 18/08/06
 */

import ACTIONS from 'constants/action.json5';

// 服务端渲染初始化store字段。不需要对应的action
const initState = {
  // 关键字id
  keywordId: null,
  // 关键字
  keyword: '',
  // 热门关键词
  hotWords: [],
  // 相关搜索关键字列表
  relWords: [],
  // 封面图
  cover: '',
};

export default (state = initState, action) => {
  const { keywordId } = action;
  switch (action.type) {
    case ACTIONS.SET_KEYWORD: {
      return {
        ...state,
        keywordId,
      };
    }
    default:
      return state;
  }
};
